import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/IntroPage.vue')
  },
  {
    path: '/role-selection',
    name: 'role-selection',
    component: () => import('../views/RoleSelection.vue')
  },
  {
    path: '/journey/:setting/:role',
    name: 'journey',
    component: () => import('../views/JourneyPage.vue'),
    children: [ // Child paths are in the same order as the steps in views/Journey-page.vue
      {
        path: 'overview',
        name: 'overview',
        component: () => import('../views/OverviewPage.vue'),
        meta: {
          label: 'Overview'
        }
      },
      {
        path: 'MM/:slide',
        name: 'MM',
        component: () => import('../views/MM.vue'),
        meta: {
          label: 'Multiple Myeloma'
        }
      },
      {
        path: 'PCE-FISH/:slide',
        name: 'PCE',
        component: () => import('../views/PCE.vue'),
        meta: {
          label: 'PCE & FISH'
        }
      },
      {
        path: 'takeaways',
        name: 'takeaways',
        component: () => import('../views/TakeawaysPage.vue'),
        meta: {
          label: 'Key Takeaways'
        }
      },
      {
        path: 'thank-you',
        name: 'thank-you',
        component: () => import('../views/ThankYouPage.vue')
      }
    ]
  },
  


  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
